import styled from '@emotion/styled'

export type SelectProps = {
  isError?: boolean
  padding?: string
  width?: string
}

export const Select = styled.select<SelectProps>`
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '12px 8px')};
  margin: 0;
  box-sizing: border-box;
  display: block;
  border: 1px solid var(--White80);
  color: ${props => (props.isError ? 'var(--Graphite)' : 'var(--Graphite)')};
  background: ${props => (props.isError ? 'var(--WarnBG)' : 'var(--White)')};

  &:focus-visible {
    border: solid 1px var(--White90);
    outline: solid 1px var(--White90);
  }

  &:focus {
    border: solid 1px var(--White90);
    outline: solid 1px var(--White90);
  }
`
